import { CAType } from './config';

export function getCASourceType(caType: CAType | string | undefined): string {
  let source_type = 'ca_data-all';
  if (caType === CAType.Server || caType === 'Servers') {
    source_type = 'ca_data';
  } else if (caType === CAType.Workstation) {
    source_type = 'ca_data-workstations';
  }

  return source_type;
}
